module.exports = __webpack_public_path__ + "static/media/outtextLogo.d4e5b41a.svg";